module.exports = __webpack_public_path__ + "img/1.ac760b38.png";